import React, { FC } from 'react';
import { useIsDesktop } from 'src/hooks/useIsDesktop';
import { DashboardMessages } from './DashboardMessages';
import { DashboardMessagesPlaceholder } from './DashboardMessagesPlaceholder';

export const DashboardMessagesIndexRoute: FC = () => {
  const isDesktop = useIsDesktop(768);

  if (isDesktop) {
    return <DashboardMessagesPlaceholder />;
  }

  return <DashboardMessages />;
};
